import { render, staticRenderFns } from "./SvgPlayTriangle.vue?vue&type=template&id=3a2b7010&lang=pug&"
import script from "./SvgPlayTriangle.vue?vue&type=script&lang=js&"
export * from "./SvgPlayTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports